import { render } from "./tw-ws-table.vue?vue&type=template&id=a241cac0"
import script from "./tw-ws-table.vue?vue&type=script&lang=js"
export * from "./tw-ws-table.vue?vue&type=script&lang=js"
script.render = render

export default script